/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impressum_Wirtschaftsid_TextInputs */

const en_impressum_wirtschaftsid_text = /** @type {(inputs: Impressum_Wirtschaftsid_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A business identification number (Wirtschafts-Identifikationsnummer) pursuant to Section 139c AO has not yet been assigned. Assignment is pending from the Federal Central Tax Office.`)
};

const de_impressum_wirtschaftsid_text = /** @type {(inputs: Impressum_Wirtschaftsid_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Wirtschafts-Identifikationsnummer nach SS 139c AO wurde noch nicht zugeteilt. Die Zuteilung durch das Bundeszentralamt fuer Steuern steht aus.`)
};

const fr_impressum_wirtschaftsid_text = /** @type {(inputs: Impressum_Wirtschaftsid_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un numéro d'identification économique (Wirtschafts-Identifikationsnummer) conformément au § 139c AO n'a pas encore été attribué. L'attribution est en attente auprès de l'Office central fédéral des impôts.`)
};

const es_impressum_wirtschaftsid_text = /** @type {(inputs: Impressum_Wirtschaftsid_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no se ha asignado un número de identificación empresarial (Wirtschafts-Identifikationsnummer) conforme al artículo 139c AO. La asignación está pendiente de la Oficina Central Federal de Impuestos.`)
};

const it_impressum_wirtschaftsid_text = /** @type {(inputs: Impressum_Wirtschaftsid_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un numero di identificazione aziendale (Wirtschafts-Identifikationsnummer) ai sensi del §139c AO non è ancora stato assegnato. L'assegnazione è in attesa presso l'Ufficio federale delle imposte.`)
};

const nl_impressum_wirtschaftsid_text = /** @type {(inputs: Impressum_Wirtschaftsid_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een bedrijfsidentificatienummer (Wirtschafts-Identifikationsnummer) conform § 139c AO is nog niet toegekend. Toekenning is in afwachting van het Bundeszentralamt für Steuern.`)
};

const pl_impressum_wirtschaftsid_text = /** @type {(inputs: Impressum_Wirtschaftsid_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numer identyfikacji gospodarczej (Wirtschafts-Identifikationsnummer) na podstawie § 139c AO nie został jeszcze nadany. Nadanie oczekuje od Federalnego Centralnego Urzędu Podatkowego.`)
};

const fi_impressum_wirtschaftsid_text = /** @type {(inputs: Impressum_Wirtschaftsid_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yritystunnusnumeroa (Wirtschafts-Identifikationsnummer) AO:n 139c §:n mukaisesti ei ole vielä myönnetty. Myöntäminen on vireillä liittovaltion verovirastossa.`)
};

const da_impressum_wirtschaftsid_text = /** @type {(inputs: Impressum_Wirtschaftsid_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Et erhvervsidentifikationsnummer (Wirtschafts-Identifikationsnummer) i henhold til § 139c AO er endnu ikke tildelt. Tildeling afventer fra det tyske forbundsskattecenter.`)
};

const sv_impressum_wirtschaftsid_text = /** @type {(inputs: Impressum_Wirtschaftsid_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ett företagsidentifikationsnummer (Wirtschafts-Identifikationsnummer) enligt 139c AO har ännu inte tilldelats. Tilldelning inväntas från det tyska federala skattekontoret.`)
};

/**
* | output |
* | --- |
* | "A business identification number (Wirtschafts-Identifikationsnummer) pursuant to Section 139c AO has not yet been assigned. Assignment is pending from the Fe..." |
*
* @param {Impressum_Wirtschaftsid_TextInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const impressum_wirtschaftsid_text = /** @type {((inputs?: Impressum_Wirtschaftsid_TextInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impressum_Wirtschaftsid_TextInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_impressum_wirtschaftsid_text(inputs)
	if (locale === "fr") return fr_impressum_wirtschaftsid_text(inputs)
	if (locale === "es") return es_impressum_wirtschaftsid_text(inputs)
	if (locale === "it") return it_impressum_wirtschaftsid_text(inputs)
	if (locale === "nl") return nl_impressum_wirtschaftsid_text(inputs)
	if (locale === "pl") return pl_impressum_wirtschaftsid_text(inputs)
	if (locale === "fi") return fi_impressum_wirtschaftsid_text(inputs)
	if (locale === "da") return da_impressum_wirtschaftsid_text(inputs)
	if (locale === "sv") return sv_impressum_wirtschaftsid_text(inputs)
	return en_impressum_wirtschaftsid_text(inputs)
});